import api from '../api.js';
import { iniciarRequisicao, logout } from "../../helpers/index.js";
import { STATUS_HTTP } from '../statusHTTP.js';

export const buscarComparativo = async (parametros) => {
  const url = `comparativo-preco`;
  const { data, status } = await api.post(url, parametros, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.dados;
  }

  logout();
}
